var map = {
	"./Allergien.png": 676,
	"./Beruhigungsmittel_Schlafmittel.png": 677,
	"./Blase_Niere_Prostata.png": 678,
	"./Depression.png": 679,
	"./Erkältung.png": 680,
	"./Fieber.png": 681,
	"./Haut_Schleimhaut.png": 682,
	"./Husten.png": 683,
	"./Kopfschmerz.png": 684,
	"./Magen-Darm-Beschwerden.png": 685,
	"./Nahrungsergaenzungsmittel_Vitaminmangel.png": 686,
	"./Pflegeprodukte.png": 687,
	"./Pilzerkrankungen.png": 688,
	"./Schmerzen.png": 689,
	"./Schnupfen.png": 690,
	"./Schwindel.png": 691,
	"./Verhuetung.png": 692,
	"./Verletzung.png": 693,
	"./default.png": 694,
	"./default_grey.png": 695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;